"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
function setAttendeeContentShareAudioProfile(attendeeId, contentShareAudioProfile) {
  return function (dispatch) {
    var action = {
      type: _types.BROADCAST_SET_ATTENDEE_MUSIC_PROFILE,
      payload: {
        attendeeId: attendeeId,
        contentShareAudioProfile: contentShareAudioProfile
      }
    };
    dispatch(action);
  };
}
var _default = exports["default"] = setAttendeeContentShareAudioProfile;